import { useState } from "react";
import { Box, Typography, Modal, Button, useTheme, useMediaQuery } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import LoadingButton from "@mui/lab/LoadingButton";

import { deleteProject } from "../../services/apis";
import { selectProjectId } from "../../redux/Slice/ProjectDirectory/ProjectDirectorySlice";

const getModalStyle = (isSmallScreen: boolean) => ({
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: isSmallScreen ? "90vw" : 404,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
  maxHeight: "95vh",
  overflowY: "auto",
});

interface DeleteProjectModelProps {
  openDeleteProjectModel: boolean;
  setOpenDeleteProjectModel: (open: boolean) => void;
  setEnableSearchQuery: (enable: boolean) => void;
  // onDeleteSuccess: () => void;
  setAlertState: any;
}

export default function DeleteProjectModel({
  openDeleteProjectModel,
  setOpenDeleteProjectModel,
  setEnableSearchQuery,
  // onDeleteSuccess,
  setAlertState,
}: DeleteProjectModelProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const selectProjectID = useSelector(selectProjectId);
  const [isLoading, setIsLoading] = useState(false);

  const deleteMutation = useMutation({
    mutationFn: deleteProject,
    onSuccess: (data) => {
      console.log("Project deleted successfully:", data);
      setOpenDeleteProjectModel(false);
      setEnableSearchQuery(true);
      setIsLoading(false);
      setAlertState({ isAlert: true, severity: "success", title: "", description: "Project deleted.", resetOpen: true });
      // onDeleteSuccess();
    },
    onError: (error) => {
      setIsLoading(false);
      console.error("Error deleting project:", error);
    },
  });

  const handleClose = () => setOpenDeleteProjectModel(false);
  const handleDeleteClick = () => {
    setIsLoading(true);
    deleteMutation.mutate(selectProjectID);
  };

  return (
    <Modal open={openDeleteProjectModel} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box sx={getModalStyle(isSmallScreen)}>
        <Typography id="modal-modal-title" variant="h6">
          Are you sure you want to delete this project?
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <Typography id="modal-modal-title" variant="body1">
          Proceeding with this action will delete the project and its associated sites and units.
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button variant="text" color="primary" size="medium" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            loading={isLoading}
            variant="contained"
            onClick={handleDeleteClick}
            sx={{
              backgroundColor: "#D32F2F",
            }}
          >
            Delete
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
}
